// extracted by mini-css-extract-plugin
export default {"wrapper":"rB-z","viewport":"sB-z","container":"tB-z","slide":"uB-z"};